window.AddOrRemoveQuantity = (quantity, inputId, packageSize = 1) => {
    let inputElement = document.getElementById(inputId);
    let hiddenInputElement = document.getElementById("count-" + inputId);
    let maxValue = Math.floor(999 / packageSize);
    let minValue = 1;
    let sum = 0;

    if (packageSize > 1) {
        sum = parseInt(hiddenInputElement.value) + parseInt(quantity);

        if (sum < minValue) {
            hiddenInputElement.value = minValue;
            inputElement.value = minValue * packageSize;
        } else if (sum > maxValue) {
            hiddenInputElement.value = maxValue;
            inputElement.value = maxValue * packageSize;
        } else {
            hiddenInputElement.value = sum;
            inputElement.value = sum * packageSize;
        }
    }
    else {
        sum = parseInt(inputElement.value) + parseInt(quantity);

        if (sum < minValue) {
            inputElement.value = minValue * packageSize;
        } else if (sum > maxValue) {
            inputElement.value = maxValue * packageSize;
        } else {
            inputElement.value = sum * packageSize;
        }
    }
};

window.ChangeQuantity = (quantity, inputId) => {
    let maxValue = 999;
    let minValue = 1;

    let inputElement = document.getElementById(inputId);

    if (quantity > maxValue) {
        quantity = maxValue;
    }
    else if (quantity < minValue || quantity == "") {
        quantity = minValue;
    }
    if (inputElement) {
        inputElement.value = quantity;
    }
};